import React from 'react'

export default function AboutOne() {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-6 mb-5 mb-md-0 pb-md-4">
                    {/* <div className="text-center mb-5 position-relative">
                    </div> */}
                    <h3 className="text-primary text-uppercase text-center text-md-start mt-1 mt-md-5">Quiénes somos</h3>
                    <iframe title='videoVimeo' width='100%' height='80%' src='https://player.vimeo.com/video/1077452242?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'></iframe>
                </div>

                <div className="col-lg-6 col-md-6 mt-4 mt-md-0 pt-4 pt-md-0">
                    <div className="section-title ms-lg-5">
                        <h4 className="title my-1 my-md-3">85 años de Experiencia, Innovación y Atención Integral en Salud</h4>
                        <p className="para-desc text-muted">
                            En Hospital Aranda de la Parra, combinamos calidez humana con atención médica de primer nivel, ofreciendo un servicio cercano y oportuno. Con más de 85 años de experiencia en salud, nos hemos consolidado como un referente en diagnóstico, tratamientos especializados y tecnología de vanguardia en México.
                        </p>
                        <p className="para-desc text-muted">
                            Nuestro equipo multidisciplinario es el pilar de nuestra excelencia en servicio: médicos, enfermeras, paramédicos, personal de limpieza, cocina, administrativos y más, quienes, con su compromiso diario, hacen posible una atención médica integral y de calidad. La tecnología médica avanzada es nuestra aliada, pero el verdadero valor de nuestro hospital radica en las personas que trabajan día a día por tu bienestar.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
